import { Component, Input } from '@angular/core';
import { BaseAvatarSize, CustomerProfileRatingListItemResponse } from 'base';

@Component({
  selector: 'base-customer-employee-review-item',
  templateUrl: './base-customer-employee-review-item.component.html',
})
export class BaseCustomerEmployeeReviewItemComponent {
  @Input({ required: true }) review: CustomerProfileRatingListItemResponse | undefined;

  avatarSize = BaseAvatarSize;
}
